module.exports = __webpack_public_path__ + "img/img01.e417326b.png";